import Controller from '@ember/controller';
import { computed, get, getProperties, set } from '@ember/object';
import { sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { task } from 'ember-concurrency';
import RSVP from 'rsvp';

export default Controller.extend({
  router: service(),
  store: service(),
  storeCache: service(),
  flashMessages: service(),

  q: '',

  sortBy: ['user.displayName:asc'],
  sortedItems: sort('model.items', 'sortBy'),
  filteredItems: computed('q', 'sortedItems', function () {
    let { q, sortedItems } = getProperties(this, 'q', 'sortedItems');
    if (isEmpty(q)) {
      return sortedItems;
    }
    q = q.toLowerCase();
    return sortedItems.filter((item) => {
      return get(item, 'user.displayNameLowerCase').indexOf(q) >= 0;
    });
  }),
  selectedItems: computed('model.items.@each.isSelected', function () {
    return get(this, 'model.items').filter((item) => {
      return get(item, 'isSelected');
    });
  }),

  save: task(function* () {
    let fundId = get(this, 'model.fund.id');
    let { store, selectedItems } = getProperties(
      this,
      'store',
      'selectedItems',
    );
    let savePromises = [];
    selectedItems.forEach((item) => {
      let newUserFund = store.createRecord('admin/user-fund', {
        userId: get(item, 'user.id'),
        fundId: fundId,
      });
      savePromises.push(newUserFund.save());
    });
    yield RSVP.allSettled(savePromises);
    this.storeCache.breakFindAllCache('admin/user-fund');

    // TODO: Eric - how to refresh the route
    this.router.refresh('admin').then(() => {
      this.router.transitionTo('admin.funds.fund');
    });
  }).drop(),

  reset() {
    set(this, 'q', '');
  },
});
